<template>
  <div class="page">
    <div class="container">
      <div class="flex align-center">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>我的方案</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flex-column align-center mt-90" v-if="schemeList.length === 0">
        <img src="/images/zanwu.png" alt="" class="mb-28">
        <div class="color-94 font-16 font-yahei mb-60">暂未找到任何方案哦</div>
        <div class="btn-40 bg-292a2e color-ff font-16 radius-round w-226 flex align-center" @click="onAdd">
          <i class="el-icon-plus mr-10"></i>
          创建新方案
        </div>
      </div>
      <div v-else class="mt-32 mb-80">
        <div class="flex justify-center p-relative">
          <div class="btn-40 bg-292a2e color-ff font-16 radius-round w-226 flex align-center z-index2" @click="onAdd">
            <i class="el-icon-plus mr-10"></i>
            创建新方案
          </div>
          <div class="hr through"></div>
        </div>
      </div>
      <div class="list flex flex-wrap">
        <div class="list-item flex align-center" :class="index%3 === 0 ? '' : 'ml-30'" v-for="(item, index) in schemeList" :key="index" @mouseenter="toEnter(index)" @mouseleave="toLeave" @click="toDetail(item.id)">
          <div class="flex-1 w-0">
            <img src="/images/icon-zhengzhuangfangan.png" alt="" class="mb-24">
            <div class="font-30 color-292a2e font-yahei text-overflow">{{item.name}}</div>
            <div class="flex flex-wrap align-center color-292a2e font-16 font-yahei mb-26">
              <div class="flex align-center flex-wrap" v-if="item.customerSpaceList && item.customerSpaceList.length>0">
                <div v-for="(item, index) in item.customerSpaceList" :key="index" class="flex align-center">
                  <i class="el-icon-plus font-14 mlr-5" v-if="index !== 0"></i>
                   <div  class="lh-24">{{item.name}}</div>
                </div>
                <div class="mlr-5">=</div> 
                <div class="color-c19357 font-arial font-bold font-16 lh-24">{{item.totalNum || 0}}</div>
                <div class="lh-24">件</div>
              </div>
              <div v-else class="flex align-center">
                <div class="color-c19357 font-arial font-bold font-16 lh-24">{{item.totalNum || 0}}</div>
                <div class="lh-24">件</div>
              </div>
            </div>
            <!-- <div class="font-16 color-292a2e font-yahei mb-26">客厅 + 主卧 + 次卧 + 书房 = 12件</div> -->
            <div class="font-30 color-c19357">¥{{Utils.toFixedNum(item.price)}}</div>
          </div>
          <img :src="hoverIndex === index ? '/images/jinruxiangqinghei.png' : '/images/jinruxiangqingbaibeijing.png'" alt="" class="ml-30">
        </div>
      </div>
    </div>
    <div class="modal" v-if="isAdd" @scroll.stop.prevent @touchmove.prevent>
      <div class="content">
        <div class="flex align-center justify-space-between p-10">
          <div class="font-16 color-292a2e font-yahei">创建新方案</div>
          <img src="/images/guanbi.png" alt="" @click="onCloseAdd" class="cursor">
        </div>
        <el-input v-model="addSchemeName" type="textarea" resize="none" maxlength="15" class="font-32 text-center mtb-38" placeholder="点击输入方案名称(15字内)"></el-input>
        <div class="hr mb-20"></div>
        <div class="flex justify-center mb-20">
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei" @click="submitAdd">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "MyScheme",
  components: {},
  props: ["keywords"],
  data () {
    return {
      isAdd: false,
      addSchemeName: null,
      schemeList: [],
      hoverIndex: null,
      page:1,
      limit: 12,
      totalNum: 0
    }
  },
  created () {
    this.getData()
  },
  mounted () {
  },
  watch: {
    keywords (val) {
    this.keywords = val
    this.getData()
    }
  },
  methods: {
    getData () {
      let params = {
        keywords: this.keywords
      }
      this.axios.post(`customerProgramme/list`, params).then(res => {
        if (res.data.success) {
          let list = res.data.data
          for (let info of list) {
            let num = 0
            let price = 0
            if (info.customerSpaceList.length > 0) {
                for (let i=0;i<info.customerSpaceList.length;i++) {
                  let spacePrice = 0
                  let spaceNum = 0
                  for (let j=0;j<info.customerSpaceList[i].customerSpaceGoodsList.length;j++) {
                      spaceNum = spaceNum + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity
                      spacePrice =spacePrice + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity * (info.customerSpaceList[i].customerSpaceGoodsList[j].isPeferential ? info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPreferentialPrice : info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPrice)
                  }
                  info.customerSpaceList[i].spaceNum = spaceNum
                  info.customerSpaceList[i].spacePrice= spacePrice
                  num = num + info.customerSpaceList[i].spaceNum
                  price = price + info.customerSpaceList[i].spacePrice
                }
            }
            info.totalNum = num
            info.totalPrice = price
          }
          this.schemeList = list
          this.total = res.data.data.total
        }
      })
    },
    toDetail (id) {
      let url = this.$router.resolve({name: 'MySchemeDetail',query: {id: id + '.html'}})
      window.open(url.href,'_blank')
    },
    onAdd () {
      this.isAdd = true
    },
    submitAdd () {
      if (!this.addSchemeName) {
        this.$message({
            type: 'warning',
            message: '请输入方案名称!'
          })
      } else {
        let params = {
          name: this.addSchemeName
        }
        this.axios.post(`customerProgramme/save`, params).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.isAdd = false
          this.getData()
        } else {
          this.$message.error(res.data.message)
        }
      })
      }
    },
    onCloseAdd () {
      this.isAdd = false
    },
    toEnter (e) {
      this.hoverIndex = e
    },
    toLeave () {
      this.hoverIndex = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3;
    padding-bottom: 105px;
    padding-top: 32px;
    height: 100%;
  }
  .w-153{
    width: 153px;
  }
  .w-226{
    width: 226px;
  }
  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  .hr.through{
    position: absolute;
    top: 20px;
    left: 0;
    z-index: 1;
  }
  .z-index2{
    z-index: 2
  }
  .list-item{
    width: 446px;
    height: 287px;
    box-shadow: 0px 30px 70px 0px 
    rgba(44, 51, 59, 0.07);
    padding: 30px;
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;
    &:hover {
      background: #c19357;
      box-shadow: 0px 30px 70px 0px rgba(193, 147, 87, 0.07);
      .color-c19357{
        color: #292a2e;
      }
    }
  }

  ::v-deep{
    .content .el-textarea__inner{
      text-align: center;
      border: 0;
      height: 115px;
      padding: 0 26px;
    }
  }
</style>
